"use strict";

exports.__esModule = true;
exports.TrackingReport = void 0;
var _Constant = require("../Utils/Constant");
var _YoLog = require("../Utils/YoLog");
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } /*
 * COPYRIGHT 2020-2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */
var TrackingReport = exports.TrackingReport = /*#__PURE__*/function () {
  TrackingReport.categoryForEvent = function categoryForEvent(event) {
    if (TrackingReport.isValidAdBreakEvent(event)) {
      return _Constant.CAT_AD_BREAK_EVENTS;
    } else if (TrackingReport.isTimelineEvent(event)) {
      return _Constant.CAT_TIMELINE_EVENTS;
    }
    return 0;
  };
  TrackingReport.isValidPlayerOperationEvent = function isValidPlayerOperationEvent(event) {
    return _Constant.PLAYER_OPERATION_EVENTS.indexOf(event) !== -1;
  };
  TrackingReport.isValidCompanionEvent = function isValidCompanionEvent(event) {
    return _Constant.COMPANION_EVENTS.indexOf(event) !== -1;
  };
  TrackingReport.isValidInteractiveEvent = function isValidInteractiveEvent(event) {
    return _Constant.INTERACTIVE_EVENTS.indexOf(event) !== -1;
  };
  TrackingReport.isValidLinearEvent = function isValidLinearEvent(event) {
    return _Constant.LINEAR_EVENTS.indexOf(event) !== -1;
  };
  TrackingReport.isValidNonLinearEvent = function isValidNonLinearEvent(event) {
    return _Constant.NON_LINEAR_EVENTS.indexOf(event) !== -1;
  };
  TrackingReport.isValidVerificationEvent = function isValidVerificationEvent(event) {
    return _Constant.VERIFICATION_EVENTS.indexOf(event) !== -1;
  };
  TrackingReport.isTimelineEvent = function isTimelineEvent(event) {
    return _Constant.TIMELINE_EVENTS.indexOf(event) !== -1;
  };
  TrackingReport.isValidAdBreakEvent = function isValidAdBreakEvent(event) {
    return _Constant.AD_BREAK_EVENTS.indexOf(event) !== -1;
  };
  TrackingReport.isValidVisibleEvent = function isValidVisibleEvent(event) {
    return _Constant.VISIBLE_EVENTS.indexOf(event) !== -1;
  };
  function TrackingReport(trackingEvent, trackingUrls, adBreakIdentifier, mediaIdentifier) {
    this.trackingEvent = trackingEvent;
    this.trackingUrls = JSON.parse(JSON.stringify(trackingUrls ? trackingUrls : []));
    this.adBreakIdentifier = adBreakIdentifier || "";
    this.mediaIdentifier = mediaIdentifier || "";
  }
  var _proto = TrackingReport.prototype;
  _proto.copy = function copy() {
    return new TrackingReport(this.trackingEvent, this.trackingUrls, this.adBreakIdentifier, this.mediaIdentifier);
  };
  _proto.addTrackingUrl = function addTrackingUrl(url) {
    if (!url) {
      _YoLog.YoLog.e("addTrackingUrl: url was null");
    } else {
      this.trackingUrls.push(url);
    }
  };
  _proto.getAdBreakIdentifier = function getAdBreakIdentifier() {
    return this.adBreakIdentifier;
  };
  _proto.getEventType = function getEventType() {
    return this.trackingEvent;
  };
  _proto.getMediaIdentifier = function getMediaIdentifier() {
    return this.mediaIdentifier;
  };
  _proto.getTrackingUrls = function getTrackingUrls() {
    return Object.assign([], this.trackingUrls);
  };
  _proto.removeTrackingUrls = function removeTrackingUrls() {
    this.trackingUrls = [];
  };
  _proto.toString = function toString() {
    var s = "";
    s += "Event:";
    s += this.trackingEvent;
    for (var _iterator = _createForOfIteratorHelperLoose(this.trackingUrls), _step; !(_step = _iterator()).done;) {
      var trackingUrl = _step.value;
      s += "\n - Url:";
      s += trackingUrl;
    }
    return s;
  };
  return TrackingReport;
}();